<template>
  <UserForm :user="user" :userClaims="newClaims" :userCompanies="companies" :userDepartmentAccess="departmentAccess" :userDefaultDepartment="defaultDepartment"></UserForm>
</template>
<script>

import {mapGetters} from 'vuex';
import users from './../../../mixins/users/users'
import UserForm from '../../../components/userManagement/userForm.vue';
export default {
  name: 'UsermanagementEdit',
  mixins: [users],
  components: {UserForm},
  data() {
    return {
      user: null,
      userData: null,
      departmentAccess: [],
      defaultDepartment: null,
      companies: [],
      pincodeCheck:null,
      newClaims: {
        root: false,
        teamlead:false,
        manager:false,
        admin: false,
        companyId: null,
        validEmail: true,
        pincode:null
      }

    };
  },
  firestore() {
    return {
      companies: this.$FB.collection('companies'),
    };
  },
  methods: {
  },
  computed: {
    ...mapGetters('users', [
      'getMe'
    ]),
    ...mapGetters('company', [
      'getCompanyDepartments'
    ]),
    claims() {
      return this.$FirebaseAuth.getClaims();
    }
  },

  async created() {
    let self = this;
    this.$FUNCTIONS.Users('getUserById', this.$route.params.id).then(function (result) {
      self.user = result.data;
      self.user.password = '';
      self.user.password2 = '';

      self.newClaims = self.user.customClaims;
      if(self.newClaims.pincode === undefined){
        self.newClaims.pincode = null
      }
    });
    let userData = await  this.$FB.collection('userData').doc(this.$route.params.id).get();
    if (userData.exists === false) {
      await this.createUserDataRecord(this.$route.params.id, self.newClaims.companyId)
      userData = await this.$FB.collection('userData').doc(this.$route.params.id).get();

    }
    this.userData = userData.data()

    if (this.userData.defaultDepartment) {
      this.defaultDepartment = this.userData.defaultDepartment
    }
    if (!this.userData.departmentAccess) {
      this.userData.departmentAccess = []
    } else {
      this.departmentAccess = this.userData.departmentAccess
    }

  }
};
</script>
<style lang="scss">

</style>
